import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../@core/auth/jwt/jwtService";

const companyId = process.env.REACT_APP_COMPANY_ID;

export const getEvent = createAsyncThunk(
  "landing/getEvent",
  async (eventId) => {
    const response = await axiosInstance.request({
      url: `/companies/${companyId}/events/${eventId}`,
      method: "get",
    });
    return { data: response.data };
  }
);

export const landingSlice = createSlice({
  name: "landing",
  initialState: {
    eventData: [],
    eventLoader: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getEvent.fulfilled, (state, action) => {
        state.eventData = action.payload.data;
        state.eventLoader = false;
      })
      .addCase(getEvent.pending, (state, action) => {
        state.eventLoader = true;
      })
      .addCase(getEvent.rejected, (state, action) => {
        state.eventLoader = false;
      });
  },
});

export default landingSlice.reducer;
